import { initializeApp } from 'firebase/app';
import { config } from '@/config';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';

// Firebase configuration from centralized config
const firebaseConfig = config.firebase;

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

// Default storage bucket - used for notes, videos, and content requiring server-side processing
const storage = getStorage(app);

// User-specific storage bucket - used for profile data like avatars
// Uses custom bucket specified in VITE_FIREBASE_USER_STORAGE_BUCKET
const userStorage = getStorage(app, import.meta.env.VITE_FIREBASE_USER_STORAGE_BUCKET);

const db = getFirestore(app);

export { app, auth, storage, userStorage, db };
